// TODO: Use MUI theme custom color when updated to > 5.0
// 4.9.9 <= doesn't support custom theme colors
export const linkColor = '#22679d';
